type RecruitmentSchedules = Array<{
  entryEnd: string | undefined;
  eventEnd: string | undefined;
}>;

// Schedules[].entryEnd, schedules[].eventEndのうち最も近い日時を取得する
export const getSheduleEnd = (schedules: RecruitmentSchedules, now: Date) => {
  let scheduleEnd = null;
  for (const schedule of schedules) {
    if (schedule.entryEnd) {
      const entryEnd = new Date(schedule.entryEnd);
      if (entryEnd > now && (!scheduleEnd || entryEnd < scheduleEnd)) {
        scheduleEnd = entryEnd;
      }
    }

    if (schedule.eventEnd) {
      const eventEnd = new Date(schedule.eventEnd);
      if (eventEnd > now && (!scheduleEnd || eventEnd < scheduleEnd)) {
        scheduleEnd = eventEnd;
      }
    }
  }

  return scheduleEnd ? {scheduleEnd} : {scheduleEnd: null};
};
